import React, { useEffect, useState } from 'react';
import Icon from '../Icon';
import * as S from './style';
import * as T from '../Typography';

const CopyLink = ({
  link = 'https://www.test.com/test',
  big,
  title,
  ...props
}) => {
  const [copied, setCopied] = useState(false);

  const copyCodeToClipboard = () => {
    setCopied(false);
    const el = document.createElement('textArea');
    el.value = link;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    setCopied(true);
  };

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 750);
    }
  }, [copied]);

  if (big)
    return (
      <S.Container {...props}>
        <S.BigWrapper>
          {title && (
            <T.P weight={700} mb="4">
              {title}
            </T.P>
          )}
          <T.P
            weight={700}
            color="primary"
            bold
            style={{ textDecoration: 'underline' }}
            mb="4"
          >
            {link}
          </T.P>
          <S.CopyBtn ml="3" onClick={copyCodeToClipboard} big={big}>
            <T.H5 weight={700} color="gray9">
              Copy
            </T.H5>
            <Icon icon="copy" color="gray9" width="16" height="16" ml="1" />
          </S.CopyBtn>
          {copied && (
            <Icon
              icon="circleTick"
              text="Copied!"
              color="primary"
              width="16"
              height="16"
              mt="2"
            />
          )}
        </S.BigWrapper>
      </S.Container>
    );
  return (
    <S.Container {...props}>
      <S.Wrapper>
        <T.P color="primary" bold style={{ textDecoration: 'underline' }}>
          {link}
        </T.P>
        <S.CopyBtn ml="3" onClick={copyCodeToClipboard}>
          <T.H5 color="gray9">Copy</T.H5>
          <Icon icon="copy" color="gray9" width="16" height="16" ml="1" />
        </S.CopyBtn>
      </S.Wrapper>
      {copied && (
        <S.IconWrapper>
          <Icon
            icon="circleTick"
            text="Copied!"
            color="primary"
            width="16"
            height="16"
            mr="4"
            mt="2"
            style={{ justifyContent: 'flex-end' }}
          />
        </S.IconWrapper>
      )}
    </S.Container>
  );
};

export default CopyLink;
